'use strict';

/* eslint-disable global-require */

if (!module.hot || process.env.NODE_ENV === 'production') {
  module.exports = require('./AppContainer.prod');
} else {
  module.exports = require('./AppContainer.dev');
}


//////////////////
// WEBPACK FOOTER
// ./~/react-hot-loader/lib/AppContainer.js
// module id = 1019
// module chunks = 0